var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReactNative(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 91,
    viewBox: "0 0 92 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_100_87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8387 33.75C14.95 36.3 8.5 40.6688 8.5 45.6563C8.5 53.5575 25.0188 60 45.4375 60C48.2125 60 50.1625 59.8537 52.75 59.6362",
    stroke: "#00D8FF",
    strokeWidth: 7.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8887 59.6251C36.34 57.3901 34.8662 55.3764 33.4637 52.8751C23.1475 34.5001 20.3837 16.2376 27.3512 12.1014C31.6637 9.4876 38.7775 13.0501 46.0037 20.5539",
    stroke: "#00D8FF",
    strokeWidth: 7.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1088 57.7013C22.4763 67.7813 23.0088 75.3862 27.2088 77.9325C33.895 81.9825 47.41 70.59 57.37 52.4175C58.72 49.905 59.93 47.4325 61 45",
    stroke: "#00D8FF",
    strokeWidth: 7.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 69.45C53.23 76.95 60.3138 80.5125 64.6675 77.8988C71.605 73.7663 68.8713 55.5037 58.5438 37.125C57.1038 34.5862 55.63 32.61 54.1187 30.375",
    stroke: "#00D8FF",
    strokeWidth: 7.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.225 56.25C77.02 53.6738 83.5 49.3125 83.5 44.34C83.5 36.4275 66.97 30 46.5812 30C43.78 30 41.8338 30.1087 39.25 30.3262",
    stroke: "#00D8FF",
    strokeWidth: 7.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 45.0001C32.0687 42.5251 33.2763 40.0951 34.63 37.5826C44.5563 19.4176 58.0787 7.99507 64.8025 12.0788C68.965 14.6251 69.535 22.2263 66.9025 32.3026M46.975 45.0563H46.9375C46.9 45.5438 46.4875 45.9563 45.9625 45.9563C45.7114 45.9439 45.4745 45.8361 45.3003 45.6549C45.126 45.4736 45.0276 45.2327 45.025 44.9813C45.025 44.4563 45.4375 44.0438 45.925 44.0438H45.8875C46.375 44.0063 46.825 44.4563 46.825 44.9438",
    stroke: "#00D8FF",
    strokeWidth: 7.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_100_87",
    x: -3,
    y: 0,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.621667 0 0 0 0 0.621667 0 0 0 0 0.621667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_100_87"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_100_87",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactNative);
export default __webpack_public_path__ + "static/media/react-native.f969c83c9947d64fd53e686d52f96109.svg";
export { ForwardRef as ReactComponent };